<template>
    <div class="item-box">
        <p v-if="name" class="name">{{name}}:</p>
        <p
            ref="selectList"
            class="select-list">
            <span
                v-for="(item, index) in options"
                class="item"
                :class="{active: `${item.id}`===`${newSelect}`}"
                :key="index"
                @click="handleSelect(item)"
            >{{item.name}}</span>
        </p>
    </div>
</template>

<script>
    export default {
        name: "item-box",
        props: {
            name: String,
            options: Array,
            select: [String, Number]
        },
        watch:{
          select(vl){this.newSelect = vl},
          newSelect(vl){this.$emit('update:select',vl)},
          calcHeight(vl){
              this.$emit('onHeight', vl)
          },
            options: {
              handler(){
                  this.$nextTick(()=>{
                    this.newCalcHeight()
                  })
              },
              deep: true,
              immediate: true
            },
        },
        mounted(){
            this.$nextTick(()=>{
                this.newCalcHeight()
            })
        },
        data(){
            return {
                newSelect: this.select,
                calcHeight: 0
            }
        },
        methods: {
            handleSelect(item){
                const {id} = item
                this.newSelect = id
            },
            newCalcHeight(){
                if(this.$refs.selectList) {
                    const fn = setTimeout(()=>{
                        this.calcHeight = this.$refs.selectList.clientHeight
                        clearTimeout(fn)
                    }, 500)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.item-box{
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    /*margin-bottom: 12px;*/

    .name{
        min-width: 36px;
        margin-left: 20px;
        font-size: 14px;
        font-weight: 500;
        color: #303133;
        line-height: 20px;
        margin-right: 6px;
        margin-top: 2px;
    }

    .select-list{
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;

        .item{
            font-size: 14px;
            font-weight: 400;
            color: #909399;
            line-height: 20px;
            padding: 2px 6px;
            border-radius: 2px;
            transition: all .2s linear;
            margin-right: 4px;
            cursor: pointer;
            margin-bottom: 10px;

            &:hover,&.active{
                color: #303133;
                background: #E5E7EC;
            }
        }
    }
}
</style>
